<div class="calendar-content" (pointerleave)="preview(null)">
  <!-- Сетки сохраняют высоту и курсор дня при переходе к общей навигации. -->
  <div class="months day-months" [class.navigation-open]="activeView() !== 'day'"
    [attr.inert]="activeView() !== 'day' ? '' : null" [attr.aria-hidden]="activeView() !== 'day' ? true : null">
    @for (month of visibleMonths(); track $index; let pane = $index) {
      <div class="month">
        @if (activeView() === 'day') {
          <ng-container [ngTemplateOutlet]="calendarHeader" [ngTemplateOutletContext]="{month: month, pane: pane}" />
        } @else {
          <div class="calendar-header"><span class="header-spacer"></span></div>
        }
        <div class="calendar-body" [class.stable-size]="monthCount() === 1 && !dayContent()">
          <aur-calendar
            [class.mobile-layout]="mobile()"
            [focusDate]="focusDate()?.withDayOfMonth(1)?.equals(month) ? focusDate() : null"
            [class.compact-on-small-screens]="compactOnSmallScreens()"
            [fixedSixWeeks]="fixedSixWeeks()"
            [dayContent]="dayContent()"
            [today]="displayedToday()"
            [month]="month"
            [annualYear]="annualYear()"
            [range]="highlight()"
            [minDate]="effectiveMinDate()"
            [maxDate]="maxDate()"
            [dateFilter]="dateFilter()"
            (monthChange)="moveMonth($event, pane === 0 ? 'left' : 'right')"
            (selectedChange)="select($event)"
            (datePreview)="preview($event)"
          />
        </div>
      </div>
    }
  </div>
  @if (activeView() !== 'day') {
    <div class="navigation-panel">
      <div class="months headers">
        @for (month of headerMonths(); track $index; let pane = $index) {
          <div class="month">
            <ng-container [ngTemplateOutlet]="calendarHeader" [ngTemplateOutletContext]="{month: month, pane: pane}" />
          </div>
        }
      </div>
      <div class="period-grid" role="grid" [attr.aria-label]="periodLabel()">
        @for (row of periodRows(); track $index) {
          <div class="period-row" role="row">
            @for (cell of row; track cell.value) {
              <div class="period-cell" role="gridcell" [attr.aria-selected]="cell.selected">
                <button #periodButton type="button"
                  [attr.data-period]="cell.value"
                  [attr.aria-disabled]="cell.disabled"
                  [class.disabled]="cell.disabled"
                  [class.selected]="cell.selected"
                  [tabIndex]="periodFocus() === cell.value ? 0 : -1"
                  (focus)="periodFocus.set(cell.value)"
                  (click)="selectPeriod(cell)"
                  (keydown)="onPeriodKeydown($event, cell.value)">{{ cell.label }}</button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
@if (monthFooter()) {
  <div class="months month-footers">
    <div class="month">
      <ng-container [ngTemplateOutlet]="monthFooter()"
        [ngTemplateOutletContext]="{$implicit: 'left', month: firstMonth()}" />
    </div>
    @if (viewMode() === 'double') {
      <div class="month">
        <ng-container [ngTemplateOutlet]="monthFooter()"
          [ngTemplateOutletContext]="{$implicit: 'right', month: monthCount() === 2 ? secondMonth() : firstMonth()}" />
      </div>
    }
  </div>
}

<ng-template #calendarHeader let-month="month" let-pane="pane">
  <div class="calendar-header">
    <div class="navigation-slot">
      @if (showNavigation() && pane === 0 && (annualYear() === null || activeView() === 'day')) {
        <button type="button" [disabled]="previousBlocked()" [class.unavailable]="previousBlocked()" [attr.aria-label]="previousLabel()"
          (click)="changeMonth(-1)">
          <ng-container [ngTemplateOutlet]="navigationArrow" [ngTemplateOutletContext]="{previous: true}" />
        </button>
      }
    </div>
    <div class="calendar-title" aria-live="polite" aria-atomic="true">
      <button type="button" class="title-button"
        [class.active-view]="activeView() === 'month' && activePane() === pane"
        [attr.aria-pressed]="activeView() === 'month' && activePane() === pane"
        (click)="showView('month', pane)">
        {{ locale.months[month.monthValue() - 1] }}
      </button>
      @if (annualYear() === null) {
        <button type="button" class="title-button"
          [class.active-view]="activeView() === 'year' && activePane() === pane"
          [attr.aria-pressed]="activeView() === 'year' && activePane() === pane"
          (click)="showView('year', pane)">{{ month.year() }}</button>
      }
    </div>
    <div class="navigation-slot">
      @if (showNavigation() && pane === monthCount() - 1 && (annualYear() === null || activeView() === 'day')) {
        <button type="button" [disabled]="nextBlocked()" [class.unavailable]="nextBlocked()" [attr.aria-label]="nextLabel()"
          (click)="changeMonth(1)">
          <ng-container [ngTemplateOutlet]="navigationArrow" />
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #navigationArrow let-previous="previous">
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false">
    <path d="M9.4 6 8 7.4 12.6 12 8 16.6 9.4 18 15.4 12Z"
      [attr.transform]="previous ? 'rotate(180 12 12)' : null" />
  </svg>
</ng-template>
